import React, { useContext } from "react";
import classnames from "classnames";
import Styles from "./HeroSection.module.scss";
import { AppContext } from "@vahak/core/dist/app-context";
import AppImg from "../../../utils/AppImg";
import Link from "next/link";

//Icons
import ArrowRightWhite from "@vahak/core/dist/icons/arrow-right-white.svg";

interface HeroSectionProps {
    bannerTitle?: string;
    bannerText?: string;
    hrefLabel?: string;
    hrefURL?: string;
    srcURL?: string;
    srcSetURL?: string;
    sectionClass?: string;
    imgboxClass?: string;
    textWrapClass?: string;
    imgColClass?: string;
    altText?: string;
    onLinkClick?: Function;
}

const HeroSection = ({
    bannerTitle,
    bannerText,
    hrefLabel,
    hrefURL,
    srcURL,
    sectionClass,
    imgboxClass,
    textWrapClass,
    imgColClass,
    altText,
    onLinkClick
}: HeroSectionProps) => {
    const { isMobile } = useContext(AppContext);

    return (
        <section className={classnames(Styles.main, sectionClass)}>
            <div className={classnames(Styles.container, "container")}>
                <div className={Styles.row}>
                    <div className={classnames(Styles.colText)}>
                        <div className={classnames(Styles.textWrap, textWrapClass)}>
                            <h1>{bannerTitle}</h1>
                            <p>{bannerText}</p>
                            <Link
                                href={`${hrefURL}`}
                                target="_blank"
                                onClick={() => {
                                    onLinkClick && onLinkClick();
                                }}
                            >
                                {hrefLabel}
                                <ArrowRightWhite />
                            </Link>
                        </div>
                    </div>
                    <div className={classnames(Styles.colImage, imgColClass)}>
                        <div className={classnames(Styles.imgBox, imgboxClass)}>
                            <AppImg
                                src={`${srcURL}`}
                                alt={altText}
                                layout="responsive"
                                width={isMobile ? "280" : "490"}
                                height={isMobile ? "233" : "400"}
                                priority
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroSection;
